import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8a61b74e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=8a61b74e&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=8a61b74e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a61b74e",
  null
  
)

export default component.exports